var _defs, _path, _polygon, _g, _path2, _path3, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKmsLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 139.07 38.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#929292;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#646363;}.cls-5{fill:#24bbe7;}.cls-6{fill:#59bba8;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 139.07,
    height: 38.73
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.53,33.76h5.19L69.45,19.05,79,5.17h-5L64.49,19.05Zm-16,0H63V5.17H58.58Z",
    transform: "translate(0 0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.71 33.78 89.35 33.78 89.35 10.29 89.97 10.29 96.75 27.34 101.59 27.34 108.37 10.29 108.99 10.29 108.99 33.78 113.67 33.78 113.67 5.15 105.57 5.15 99.17 22.24 92.78 5.15 84.71 5.15 84.71 33.78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.44,5.68a63.5,63.5,0,0,0-9.06-1c-5.72,0-9.52,2.38-9.52,8.14,0,5,2.67,6.85,8.85,8.44,4.39,1,5.68,1.88,5.68,4.3,0,3-1.63,4.6-5.18,4.6-3,0-8.6-.76-8.6-.76l-.46,3.72a60.82,60.82,0,0,0,9.36,1.13c5.63,0,9.56-2.72,9.56-9,0-4.89-2.17-6.48-8.19-8.15-4.88-1.33-6.39-2-6.39-4.63,0-2.47,1.8-3.72,5.31-3.72,2.42,0,8.27.67,8.27.67Z",
    transform: "translate(0 0)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M0,28.24l1.49-1.18L0,26.22v2ZM18.36,0,1.49,13.23,11.67,19l6.69-5.27Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.25,23.41l1.49.85v-2ZM20.38,0V13.77l6.73,3.85,10.15-8Z",
    transform: "translate(0 0)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "0 28.24 18.36 38.65 18.36 24.88 0 14.39 0 28.24"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "20.38 24.99 20.38 38.73 38.74 24.26 38.74 10.42 20.38 24.99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmsLogoShort);
export default __webpack_public_path__ + "static/media/kms_logo_short.7b55b67dab65bf8f6068bc08090d94d1.svg";
export { ForwardRef as ReactComponent };